"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrMapControlPosition = exports.mapOptions = exports.defaultCenter = void 0;
exports.defaultCenter = {
    lat: -3.745,
    lng: -38.523,
};
exports.mapOptions = {
    streetViewControl: false,
    scaleControl: false,
    fullscreenControl: false,
    gestureHandling: 'greedy',
    mapTypeControl: true,
    mapTypeControlOptions: {
        position: 3,
    },
};
var FdrMapControlPosition;
(function (FdrMapControlPosition) {
    FdrMapControlPosition["BOTTOM_CENTER"] = "BOTTOM_CENTER";
    FdrMapControlPosition["BOTTOM_LEFT"] = "BOTTOM_LEFT";
    FdrMapControlPosition["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
    FdrMapControlPosition["LEFT_BOTTOM"] = "LEFT_BOTTOM";
    FdrMapControlPosition["LEFT_CENTER"] = "LEFT_CENTER";
    FdrMapControlPosition["LEFT_TOP"] = "LEFT_TOP";
    FdrMapControlPosition["RIGHT_BOTTOM"] = "RIGHT_BOTTOM";
    FdrMapControlPosition["RIGHT_CENTER"] = "RIGHT_CENTER";
    FdrMapControlPosition["RIGHT_TOP"] = "RIGHT_TOP";
    FdrMapControlPosition["TOP_CENTER"] = "TOP_CENTER";
    FdrMapControlPosition["TOP_LEFT"] = "TOP_LEFT";
    FdrMapControlPosition["TOP_RIGHT"] = "TOP_RIGHT";
})(FdrMapControlPosition || (exports.FdrMapControlPosition = FdrMapControlPosition = {}));
//# sourceMappingURL=fdr-map.constants.js.map